import {Select} from 'Components/Tailwind/Select';
import React from 'react';
import {AstView, EnrichedAstNode} from 'rendition-core';

interface Props {
    anchor: 'left' | 'right' | 'top' | 'bottom';
    node: EnrichedAstNode;
    view: AstView;
    setView: (view: AstView) => void;
}

export const AbsoluteUnitsSelect = React.forwardRef<HTMLDivElement, Props>(({node, anchor, setView, view}, ref) => {
    const value = node.inputLayoutAbstraction.units?.[anchor] || 'px';

    return (
        <div className="absolute h-8 w-auto" ref={ref}>
            <Select
                selected={value}
                setSelected={(value) => {
                    node.inputLayoutAbstraction.units = {
                        ...node.inputLayoutAbstraction.units,
                        [anchor]: value,
                    };
                    setView({...view});
                }}
                buttonClassNames="w-auto max-w-[90px] max-h-[30px]"
                optionsClassNames="w-[72px] z-[500]"
                items={['px', '%', 'em', 'rem', 'vw']}
            />
        </div>
    );
});
